<template>
  <form @submit="onSubmit">
    <div
      v-if="error"
      class="border-2 border-danger rounded-lg px-4 py-2 mt-0 mb-4 text-danger-dark font-bold bg-danger-light"
    >
      {{ error }}
    </div>

    <div class="mb-4">
      <label for="username">
        Your Username
      </label>
      <input
        v-model="username"
        type="text"
        name="username"
        placeholder="Username"
        :disabled="loading"
      />
    </div>
    <div class="mb-4">
      <label for="password">
        Your Password
      </label>
      <input
        v-model="password"
        class="mb-3"
        name="password"
        type="password"
        placeholder="********"
        :disabled="loading"
      />
      <!-- <p class="text-red text-xs italic">Please choose a password.</p> -->
    </div>

    <div class="flex justify-start mb-4">
      <Button
        class="primary flex-1 justify-center py-2 rounded-lg"
        type="submit"
        :disabled="loading"
        :loading="loading"
      >
        Sign In
      </Button>
      <!-- <a class="flex-1 self-center inline-block align-baseline font-bold text-xs text-grey hover:text-grey-darker" href="#">
          Forgot Password?
        </a> -->
    </div>
  </form>
</template>

<script>
import trim from "lodash.trim";
import { usernamePasswordAuth, getAccountId } from "@/lib/auth";

export default {
  name: "UsernamePassword",

  data: () => ({
    password: "",
    username: "",
    error: "",
    loading: false,
  }),
  methods: {
    onSubmit: async function(e) {
      e.preventDefault();
      if (this.password === "" || this.username === "") return false;

      this.loading = true;
      this.error = "";

      try {
        // Try and login
        await usernamePasswordAuth({
          Username: trim(this.username),
          Password: trim(this.password),
          apolloClient: this.$apollo.provider.defaultClient,
        });

        this.$gtm.trackEvent({
          event: "promo-login",
          accountId: getAccountId(),
          loginType: "usernamePassword",
        });

        this.$emit("login-success");
      } catch (error) {
        this.loading = false;
        this.error = error.message;
        this.$emit("login-error");
      }
    },
  },
};
</script>

<style scoped></style>
